import angular from "angular";

angular
	.module('app')
	.component('packetsControl', {
		template: require('./packets-control.html'),
        controller: ['$http', '$uibModal', controller],
        bindings: {
            courses: '<'
        }
    });
            
function controller($http, $uibModal) {
        
	let $ctrl = this;

	$ctrl.page = 1;

	$ctrl.perPage = 10;

	$ctrl.packets = [];

	$ctrl.$onInit = () => {
	    $ctrl.getList();
    };

	$ctrl.getList = () => {
	    $ctrl.loading = true;

	    $http
            .get('/admin/packets/get-list', {
                params: {
                    page: $ctrl.page
                }
            })
            .then(
                res => {
                    $ctrl.packets = res.data.data;
                    $ctrl.total = res.data.total;
                }
            )
            .catch(
                err => {
                    console.log(err);
                }
            )
            .finally(
                () => {
                    $ctrl.loading = false;
                }
            );
    };

	$ctrl.openCreateModal = () => {
        $uibModal
            .open({
                component: 'packetCreateModal',
                resolve: {
                    courses() {
                        return $ctrl.courses;
                    }
                },
                size: 'lg',
            })
            .result
            .then(res => {
                $ctrl.getList();
            });
    };
}